import script from "./DashboardNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardNavbar.vue?vue&type=style&index=0&id=616221f0&lang=scss"

const __exports__ = script;

export default __exports__